
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/awscodepipeline/thanks",
      function () {
        return require("private-next-pages/services/awscodepipeline/thanks.tsx");
      }
    ]);
  